import {
  CommitmentChoiceDto,
  CompetitionResultDto,
  DriverCompetitionDetailDto,
  DriverLeadTotalsDto,
  DriverTeamInformation,
  FleetCompetitionDetailDto,
  FleetLogoDto,
  FleetWeeklyDto,
  LeagueRankingDto,
  RecordingsDto,
  TeamChartInformation,
  TeamLeadMeasure,
  Tractor,
} from '@app/core/driver-wig.model';
import { DriverCommitmentConfiguration, CommitmentStatus } from '@app/shared/shared.models';
import { Daily5Model } from '@app/wig-daily5-form/wig-daily5-form.model';
import { IDriverWigService } from '../interface/IDriverWigService';

export class MockDriverWigService implements IDriverWigService {
  constructor() {}

  creditEligibleCall(
    driverId: string,
    fleetWeeklyId: number,
    driverWeeklyId: number
  ): Promise<number> {
    const promise = new Promise<number>((resolve, reject) => {
      resolve(4);
    });
    return promise;
  }

  creditEligibleRecording(driverId: string, driverWeeklyId: number): Promise<number> {
    const promise = new Promise<number>((resolve, reject) => {
      resolve(4);
    });
    return promise;
  }

  getCalledConference(driverId: string, weekStartDate: Date): Promise<boolean> {
    const promise = new Promise<boolean>((resolve, reject) => {
      resolve(true);
    });
    return promise;
  }

  getCommitmentChoices(driverCode: string): Promise<CommitmentChoiceDto[]> {
    const promise = null;
    return promise;
  }

  getCommitmentConfiguration(driverCode: string): Promise<DriverCommitmentConfiguration[]> {
    const promise = null;
    return promise;
  }

  getCommitmentStatus(driverCode: string): Promise<CommitmentStatus[]> {
    const promise = null;
    return promise;
  }

  getDriverCompetitionDetails(driverId: string): Promise<DriverCompetitionDetailDto[]> {
    const promise = new Promise<DriverCompetitionDetailDto[]>((resolve, reject) => {
      resolve([
        {
          weekStart: new Date(2020, 7, 20),
          driver: 'MARGEG',
          hasCalledIn: true,
          accidents: 0.0,
          lates: 0.0,
          criticalEvents: 0.0,
        },
        {
          weekStart: new Date(2020, 7, 27),
          driver: 'MARGEG',
          hasCalledIn: true,
          accidents: 0.0,
          lates: 0.0,
          criticalEvents: 0.0,
        },
        {
          weekStart: new Date(2020, 8, 3),
          driver: 'MARGEG',
          hasCalledIn: true,
          accidents: 0.0,
          lates: 0.0,
          criticalEvents: 0.0,
        },
        {
          weekStart: new Date(2020, 8, 10),
          driver: 'MARGEG',
          hasCalledIn: true,
          accidents: 0.0,
          lates: 0.0,
          criticalEvents: 0.0,
        },
        {
          weekStart: new Date(2020, 8, 17),
          driver: 'MARGEG',
          hasCalledIn: true,
          accidents: 0.0,
          lates: 0.0,
          criticalEvents: 0.0,
        },
        {
          weekStart: new Date(2020, 8, 24),
          driver: 'MARGEG',
          hasCalledIn: true,
          accidents: 0.0,
          lates: 0.0,
          criticalEvents: 0.0,
        },
      ]);
    });
    return promise;
  }

  getDriverWeeklyLeadTotals(driverId: string, weekStartDate: Date): Promise<DriverLeadTotalsDto[]> {
    const promise = new Promise<DriverLeadTotalsDto[]>((resolve, reject) => {
      resolve([
        {
          driverWeeklyId: 293834,
          fleetWeeklyId: 7550,
          weekStart: new Date(2020, 8, 3),
          hasCalledIn: true,
          leadSubject: 'No Distracted Driving',
          leadDescription: 'Did you keep your commitment to avoid driving distracted?',
          yesCount: 0,
          totalCount: 5,
        },
        {
          driverWeeklyId: 293834,
          fleetWeeklyId: 7550,
          weekStart: new Date(2020, 8, 3),
          hasCalledIn: true,
          leadSubject: 'Trip Plan',
          leadDescription: 'Did you have a trip plan and start at planned time?',
          yesCount: 0,
          totalCount: 5,
        },
      ]);
    });
    return promise;
  }

  getFleetCompetitionDetails(fleet: string): Promise<FleetCompetitionDetailDto[]> {
    const promise = new Promise<FleetCompetitionDetailDto[]>((resolve, reject) => {
      resolve([
        {
          weekStart: new Date(2020, 7, 20),
          fleet,
          teamName: null,
          competition: 0.9950495,
          tieBreaker: 0.441919178,
          cfTieBreaker: null,
          competingFleet: null,
          goalValue: 0.0,
          winner: null,
          hasCompData: true,
          usedTiebreaker: false,
          progress: 'Completed',
        },
        {
          weekStart: new Date(2020, 7, 27),
          fleet,
          teamName: null,
          competition: 0.994623661,
          tieBreaker: 0.4076923,
          cfTieBreaker: null,
          competingFleet: null,
          goalValue: 0.0,
          winner: null,
          hasCompData: true,
          usedTiebreaker: false,
          progress: 'Completed',
        },
        {
          weekStart: new Date(2020, 8, 3),
          fleet,
          teamName: null,
          competition: 1.0,
          tieBreaker: 0.381188124,
          cfTieBreaker: null,
          competingFleet: null,
          goalValue: 0.0,
          winner: null,
          hasCompData: true,
          usedTiebreaker: false,
          progress: 'Completed',
        },
        {
          weekStart: new Date(2020, 8, 10),
          fleet,
          teamName: 'IA',
          competition: 99.4818649,
          tieBreaker: 0.433673471,
          cfTieBreaker: 0.6956522,
          competingFleet: {
            fleet: 'I6',
            fleetTeamId: 598,
            teamName: 'I6',
            competition: 100.0,
            tieBreaker: 0.6956522,
          },
          goalValue: 99.3,
          winner: 'I6',
          hasCompData: true,
          usedTiebreaker: false,
          progress: 'Completed',
        },
        {
          weekStart: new Date(2020, 8, 17),
          fleet,
          teamName: 'IA',
          competition: 99.75247,
          tieBreaker: 0.4224138,
          cfTieBreaker: 0.7037037,
          competingFleet: {
            fleet: 'I4',
            fleetTeamId: 597,
            teamName: 'I4',
            competition: 100.0,
            tieBreaker: 0.7037037,
          },
          goalValue: 99.3,
          winner: 'I4',
          hasCompData: true,
          usedTiebreaker: false,
          progress: 'Completed',
        },
        {
          weekStart: new Date(2020, 8, 24),
          fleet,
          teamName: 'IA',
          competition: 0.0,
          tieBreaker: 0.0,
          cfTieBreaker: 0.0,
          competingFleet: {
            fleet: 'IF',
            fleetTeamId: 601,
            teamName: 'IF',
            competition: 0.0,
            tieBreaker: 0.0,
          },
          goalValue: 99.3,
          winner: null,
          hasCompData: false,
          usedTiebreaker: false,
          progress: 'In Progress',
        },
      ]);
    });
    return promise;
  }

  getFleetCompetitionResults(fleet: string, weekStartDate?: Date): Promise<CompetitionResultDto> {
    const promise = new Promise<CompetitionResultDto>((resolve, reject) => {
      resolve(null);
    });
    return promise;
  }

  getFleetLeagueRankings(fleet: string): Promise<LeagueRankingDto> {
    const promise = new Promise<LeagueRankingDto>((resolve, reject) => {
      resolve(null);
    });
    return promise;
  }

  getFleetLogo(fleet: string): Promise<FleetLogoDto> {
    const promise = new Promise<FleetLogoDto>((resolve, reject) => {
      resolve({
        fleet,
        teamLogo: 'Cardinals',
      });
    });
    return promise;
  }

  getFleetsCompetitionResults(
    fleets: string[],
    weekStartDate?: Date
  ): Promise<CompetitionResultDto[]> {
    const promise = new Promise<CompetitionResultDto[]>((resolve, reject) => {
      resolve(null);
    });
    return promise;
  }

  getFleetWeekly(driverId: string): Promise<FleetWeeklyDto> {
    const promise = new Promise<FleetWeeklyDto>((resolve, reject) => {
      resolve({
        competingFleet: '',
        fleetWeeklyId: 7988,
        driverWeeklyId: 307831,
        weekStart: new Date(2020, 8, 24),
        fleet: 'IA',
        fleetTeamId: 599,
        teamName: 'IA',
        division: 'ITM',
        wigName: 'WIG INTERMODAL 10',
        wigDescription: '',
        conferenceNumber: '4352203555',
        conferenceTimes: [
          {
            conferenceDateTime: new Date(2020, 8, 26),
            timezone: 'CST',
          },
        ],
        battles: [
          {
            battleId: 2,
            battleName: 'Wildly Important Goal (WIG)',
            battleDescription: 'Increase Safe & On-Time Percent',
            graphTitle: 'Safe & On-time %',
          },
        ],
        leads: [
          {
            leadId: 5,
            leadDescription: 'Did you keep your commitment to avoid driving distracted?',
            leadSubject: 'No Distracted Driving',
            options: 'Yes|No|N/A',
            isFleetWide: true,
          },
          {
            leadId: 6,
            leadDescription: 'Did you have a trip plan and start at planned time?',
            leadSubject: 'Trip Plan',
            options: 'Yes|No|N/A',
            isFleetWide: true,
          },
        ],
        conferenceRecordingUrl:
          'https://www.uberconference.com/getmp3/AMIfv97hoinLRbDdTrDf8LRuiM4vDtQnqvrflh4cQR95YvKPd3R61yxhwN5ATTCV_BX8-5F7l5P-YaDdtQLo_bln3Vjm_k6jKAGT3WhdPq1nV2FZQriTLUQES2W33wibW2mLzzxP3cajVuzpNmos5Zi1mSG5cLpbTg.mp3',
        conferenceEmail: 'tom.fries@crengland.com',
        competingTeamId: 601,
        historicalValue: 98.8,
        goalValue: 99.3,
        type: 'QUALDR',
      });
    });
    return promise;
  }

  getLatestRecordings(driverId: string): Promise<RecordingsDto[]> {
    const promise = new Promise<RecordingsDto[]>((resolve, reject) => {
      resolve([
        {
          driverCode: 'MARGEG',
          fleetWeeklyId: 7988,
          driverWeeklyId: 307831,
          latestConferenceTime: new Date(2020, 8, 26, 13),
          weekStart: new Date(2020, 8, 24),
          conferenceRecordingUrl:
            'https://urldefense.proofpoint.com/v2/url?u=https-3A__www.uberconference.com_getmp3_AMIfv97E2Jk-5FdivXbBp7MPEVSNAvERnRbDs4VOzCzQV6eAfgIuLicHj7mGgDOmCwsN3ow8rCNu2lZAM5-2D4qfN8LH38AL8JrRh00XnOdkoPi7qTsdSys9zMUSuE-5FPdbUgAoYE4x-5FwD7E5cO8Nv-5FJB9rI-5Fzks-2DqmK-2DAQ.mp3&d=DwMCaQ&c=qcabAK3qM7yHI-o8vEuBiA&r=W3df1vWdz3wrVMNxwBLHL5BiqYQj_spZzh0HZ35U7_c&m=K4g6GWRIe29Jh3gadfUNeME4y1QTj8qcllmxkncZ8zI&s=d80OnjSXRhRVKFX9dLB5SlMaFNs1aIlsxwsy7VDSsEY&e=',
          hasRecordingUrl: true,
          wigName: 'WIG INTERMODAL 10',
          hasCalledIn: true,
          viaApp: false,
          viaEmail: false,
          viaTeamMate: true,
        },
      ]);
    });
    return promise;
  }

  getTractorsByDriverId(driverId: string): Promise<Tractor[]> {
    const promise = new Promise<Tractor[]>((resolve, reject) => {
      resolve(null);
    });
    return promise;
  }

  postCommitmentChoice(driverCode: string, lead1: number, lead2: number): Promise<string> {
    const promise = new Promise<string>((resolve, reject) => {
      resolve(null);
    });
    return promise;
  }

  saveDaily5(daily5: Daily5Model): Promise<string> {
    const promise = new Promise<string>((resolve, reject) => {
      resolve(null);
    });
    return promise;
  }

  saveRecordingClicked(driverId: string, fleetWeeklyId: number): Promise<number> {
    const promise = new Promise<number>((resolve, reject) => {
      resolve(1);
    });
    return promise;
  }

  getDriverTeamInformation(driverCode: string): Promise<DriverTeamInformation> {
    const promise = new Promise<DriverTeamInformation>((resolve, reject) => {
      resolve(null);
    });
    return promise;
  }

  getDriverTeamBattleChart(driverCode: string): Promise<TeamChartInformation> {
    const promise = new Promise<TeamChartInformation>((resolve, reject) => {
      resolve(null);
    });
    return promise;
  }

  getDriverLeadMeasure(driverCode: string): Promise<TeamLeadMeasure> {
    const promise = new Promise<TeamLeadMeasure>((resolve, reject) => {
      resolve(null);
    });
    return promise;
  }
}
